import { CONSTANTS } from 'config/constants';
import Cookies from 'js-cookie';
import { Invoice } from 'models/invoice';
import { handleDownload } from 'utils/file';

export const downloadCertificationPdf = async (invoice: Invoice): Promise<void> => {
    const uri = `${CONSTANTS.DOC_API_URI}/documents/${invoice._id}/certification`;
    const res = await fetch(uri, {
        headers: {
            authorization: Cookies.get(CONSTANTS.TOKEN_KEY) || '',
        },
    });
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    const blob = await res.blob();
    return handleDownload(`Attester-${invoice.invoiceNumber}.pdf`, blob);
};
